import React, { ReactNode } from "react"
import {
  Box, Divider, Flex, Stack, Text,
} from "@chakra-ui/react"

const RoundedList = ({ children }) => (
  <Stack spacing={0} direction="column" borderRadius="xl" bgColor="white" borderWidth={1} divider={<Divider />} overflow="hidden">
    { children }
  </Stack>
)

interface RoundedListItemProps {
  text1: string | ReactNode
  text2?: string | ReactNode
  icon?: ReactNode
  action?: ReactNode
}

export const RoundedListItem = ({
  text1, text2, icon, action,
}: RoundedListItemProps) => (
  <Flex px={6} py={6} justify="space-between" align="center" gap={4}>
    {icon}
    <Box flex={1}>
      <Text fontSize="lg" fontWeight="bold" mb={1}>{text1}</Text>
      <Text>{text2}</Text>
    </Box>
    {action}
  </Flex>
)

export default RoundedList
